import type { JobModuleOutcomeTagsProps } from "./job-module-outcome-tags.type";

import { Flex } from "antd";

import { Tag } from "@/ui/tag";
import { Tooltip } from "@/ui/tooltip";

import "./job-module-outcome-tags.style.less";

const JobModuleOutcomeTags = ({ module }: JobModuleOutcomeTagsProps) => {
  if (!module?.outcomes?.length) return null;

  return (
    <Flex className="job-module-outcome-tags">
      {module.outcomes.map((outcome) => (
        <Tooltip title={outcome.description} key={outcome.slug}>
          <Tag color={outcome.color}>{outcome.name}</Tag>
        </Tooltip>
      ))}
    </Flex>
  );
};

export default JobModuleOutcomeTags;
